import { createAction, props } from '@ngrx/store';
import { PwaPushNotificationsUserSettings } from '../../../services/pwa-push-notification/pwa-push-notifications-user-settings.type';

/**
 * Dispatched by the facade's `init()` to read the persisted subscription choice from
 * `PwaPushNotificationsLocalStorageService` into the slice.
 */
export const loadPwaPushNotificationSettings = createAction('[PwaPushNotification] Init');

/**
 * Dispatched by the init effect once the persisted settings have been read (or `undefined`,
 * for a first-time user who has never been asked).
 */
export const loadPwaPushNotificationSettingsSuccess = createAction(
    '[PwaPushNotification] Settings loaded',
    props<{ settings: PwaPushNotificationsUserSettings | undefined }>(),
);

/** Dispatched by the init effect when the storage read fails. */
export const loadPwaPushNotificationSettingsError = createAction('[PwaPushNotification] Settings load failed');

/**
 * Dispatched by the facade whenever the user's subscription choice changes (offered, subscribed).
 * Updates the slice immediately; the persist effect mirrors it to storage — the store is the
 * source of truth, storage is written on save and read only to rehydrate on the next `init()`.
 */
export const savePwaPushNotificationSettings = createAction(
    '[PwaPushNotification] Save settings',
    props<{ settings: PwaPushNotificationsUserSettings }>(),
);

export const subscribeToPushNotifications = createAction('[PwaPushNotification] Subscribe');

export const subscribeToPushNotificationsSuccess = createAction('[PwaPushNotification] Subscribe success');

export const subscribeToPushNotificationsFailure = createAction('[PwaPushNotification] Subscribe failure');

export const offerPushNotificationSubscription = createAction('[PwaPushNotification] Offer subscription');

/**
 * Dispatched at app init (once settings have loaded), on visibility resume, and whenever the
 * browser reports a subscription change, to re-check the live `PushManager` subscription against
 * what the persisted settings say we're subscribed to.
 */
export const reconcilePushSubscription = createAction('[PwaPushNotification] Reconcile subscription');

/** The live PushManager subscription is present; the user is actually subscribed. */
export const pushSubscriptionHealthy = createAction('[PwaPushNotification] Subscription healthy');

/**
 * Notification permission is no longer granted, or push is unavailable in this context (e.g.
 * `SwPush.isEnabled` is false). Either way, the user is not actually subscribed, regardless of
 * what the persisted settings say.
 */
export const pushSubscriptionInactive = createAction('[PwaPushNotification] Subscription inactive');
